import React, { useState } from 'react'
import { ProsimPromotional as AppPopup } from 'apps-marketplace'
import { SidebarV2Link, NavItemIcon, NavItem } from 'navigation'

/**
 * Nav Item Button to open the App Popup.
 */
const AppPromoButton = ({ navItem, navUI }: { navItem: NavItem, navUI: string }) => {
    const [showAppPopup, setShowAppPopup] = useState(false)

    if (navUI === 'NavUIV1') {
        console.warn('App Promo Button: is not yet supported on Nav UI V1, it will intentionally not be visible on the sidebar')
        return <></>
    }

    const onClick = () => setShowAppPopup(true)

    const shouldVisible = () => !(localStorage.getItem('appPopup-clicked') === 'true')
    if (!shouldVisible()) return <></>

    return (
        <>
            <SidebarV2Link
                icon={<NavItemIcon navItem={navItem} />}
                title={navItem.title}
                animate={!showAppPopup}
                onClick={onClick}
            />
            <AppPopup {...{ showAppPopup, setShowAppPopup }} />
        </>
    )
}

export default AppPromoButton
